import { render, staticRenderFns } from "./PersonalDetailsForm.vue?vue&type=template&id=44708a06&scoped=true&"
import script from "./PersonalDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./PersonalDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalDetailsForm.vue?vue&type=style&index=0&id=44708a06&lang=scss&scoped=true&"
import style1 from "./PersonalDetailsForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44708a06",
  null
  
)

export default component.exports